import { Observable } from "rxjs";
import { forkJoin } from "rxjs";
import { take } from "rxjs/operators";
import { BulkAction, ModalService, DataService } from "@bb-vendure/admin-ui/core";
import {
  DeleteProductTypeDocument,
  DeleteProductTypeMutation,
} from "./generated-graphql/graphql";

const deleteBulkAction: BulkAction = {
  location: "product-type-table",
  label: "Delete Selected Product type",
  icon: "trash",
  iconClass: "is-danger",
  requiresPermission: (userPermissions) =>
    userPermissions.includes('DeleteProductType'),
  onClick: ({ injector, selection, hostComponent, clearSelection }) => {
    const modalService = injector.get(ModalService);
    const dataService = injector.get(DataService);
    modalService
      .dialog({
        title: "Delete Selected Product type",
        body: `Are you sure you want to delete ${selection.length} product types?`,
        buttons: [
          { type: "secondary", label: "Cancel" },
          { type: "primary", label: "Delete", returnValue: selection },
        ],
      })
      .pipe(take(1))
      .subscribe((result) => {
        if (result) {
          const deleteObservables: Observable<DeleteProductTypeMutation>[] = [];
          for (const item in result) {
            deleteObservables.push(
              dataService.mutate(DeleteProductTypeDocument, {
                id: result[item].id,
              })
            );
          }
          forkJoin(deleteObservables).subscribe(() => {
            hostComponent.refresh();
            clearSelection();
          });
        }
      });
  },
};

export { deleteBulkAction };
